import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { RbSwitchChange } from '@inst-iot/bosch-angular-ui-components';
import { Vehicle } from 'src/app/_shared/models/vehicle';
import { VehicleInfoService } from 'src/app/_services/vehicle-info.service';
import { NavigationService } from 'src/app/_services/navigation.service';
import { environment } from 'src/environments/environment';
import { CompanyService } from 'src/app/_services/company.service';
import { resizePlotlyChart } from 'src/app/_shared/plotlyConfig';
import { UserService } from 'src/app/_services/user.service';

@Component({
  selector: 'app-insights-mgmt',
  templateUrl: './insights-mgmt.component.html',
  styleUrls: ['./insights-mgmt.component.scss']
})
export class InsightsMgmtComponent implements OnInit, OnDestroy {
  private readonly unsubscribe$ = new Subject<void>();
  @Input() fleetId: string[] = [];
  companyData: any;
  vehicles!: any;
  selectedVehicles: Vehicle[] = [];
  vehiclesData: any[] = [];
  filteredVehiclesData: any[] = [];
  compareToFleet!: boolean;
  switch = {
    checked: false,
    disabled: false
  };
  chipSelectedVehicle: any;
  dataLoadingError: boolean = false;
  switchNgModel = false;
  isMetric: boolean | undefined;

  constructor(
    private readonly navigationService: NavigationService,
    private readonly VehicleInfoService: VehicleInfoService,
    private readonly companyService: CompanyService,
    private readonly userService: UserService
  ) { }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  ngOnInit() {
    const credentials = sessionStorage.getItem(`credentials_${environment.appId}`);
    if(credentials) {
      const parsedCredentials = JSON.parse(credentials);
      this.companyService.getCompanyData(parsedCredentials.database).pipe(takeUntil(this.unsubscribe$)).subscribe({
        next: (company) => {
          this.companyData = company;
        },
        error: (error) => {
          console.error('Error fetching company:', error);
        }
      })
      this.userService.getUser(parsedCredentials.userName, parsedCredentials.database).pipe(takeUntil(this.unsubscribe$)).subscribe({
        next: (user) => {
          this.isMetric = user?.isMetric ?? null;
          console.log('User metric preference:', this.isMetric);
        },
        error: (error) => {
          console.error('Error fetching user:', error);
        }
      });
    } else {
      console.error('Error fetching credentials.');
    }
    this.vehicles = [];
    this.fetchVehicles();
  }

  fetchVehicles() {
    this.VehicleInfoService.getVehiclesWithPagination(1, 0, this.fleetId).pipe(takeUntil(this.unsubscribe$)).subscribe({
      next: (dataList) => {
        for (let data of dataList.data) {
          this.vehicles.push(data);
        }
        this.vehicles = this.vehicles.filter((v: any) => v.dataAvailable === true);
        const params = this.navigationService.currentView
        if (params.id !== undefined) {
          this.selectedVehicles = [this.vehicles.find((v: { batteryIdentifier: string; }) => v.batteryIdentifier === params.id)];
        } else if (!params.id && this.selectedVehicles.length === 0) {
          this.selectedVehicles = [this.vehicles[0]];
        }
      },
      error: (error) => {
        console.error('Error fetching Vehicles data:', error);
        this.dataLoadingError = true;
      }
    });
  }

  onVehicleSelected(selectedValue: any) {
    if (Array.isArray(selectedValue) && selectedValue.length > 0) {
      if (this.selectedVehicles.length >= 4) {
        this.selectedVehicles.shift(); // Remove the oldest selected vehicle to maintain the max limit of 3
      }
      this.selectedVehicles = [...this.selectedVehicles];
    }
  }

  switchChange($event: RbSwitchChange) {
    this.compareToFleet = $event.checked
  }

  onTabChange(tabId: string) {
    switch (tabId) {
    case 'tabItem3':
      this.onGeneralTabClick();
      break;
    case 'tabItem4':
      this.onChargingTabClick();
      break;
    case 'tabItem5':
      this.onDutyCycleTabClick();
      break;
    }
  }

  onGeneralTabClick() {
    if (this.compareToFleet) {
      resizePlotlyChart('average-ev-efficiency-chart')
      resizePlotlyChart('current-sohc-chart')
      resizePlotlyChart('stress-factors-ef-chart')
      resizePlotlyChart('vehicle-mileage-chart')
    } else {
      resizePlotlyChart('ev-condition-plot')
      resizePlotlyChart('stress-factors')
      resizePlotlyChart('sohc-over-time-chart')
      resizePlotlyChart('sohc-over-mileage')
    }
  }

  onChargingTabClick() {
    if (this.compareToFleet) {
      resizePlotlyChart('soc-delta-per-charging-procedure-ef-chart-chart')
      resizePlotlyChart('initial-state-of-charge-ef-chart')
      resizePlotlyChart('end-state-of-charge-ef-chart')
      resizePlotlyChart('soc-events-low-ef-chart')
      resizePlotlyChart('soc-events-high-ef-chart')
    } else {
      resizePlotlyChart('charged-energy-over-time')
      resizePlotlyChart('soc-delta-per-charging-procedure')
      resizePlotlyChart('regenerative-charging')
      resizePlotlyChart('soc-start-chart')
      resizePlotlyChart('soc-end-chart')
    }
  }

  onDutyCycleTabClick() {
    if (this.compareToFleet) {
      resizePlotlyChart('temp-comfort-zone-chart-ef')
      resizePlotlyChart('time-spent-extreme-temp-ef-chart')
      resizePlotlyChart('time-spent-extreme-temp-low-ef-chart')
      resizePlotlyChart('time-spent-extreme-temp-high-ef-chart')
    } else {
      resizePlotlyChart('temperature-comfort-zone-chart')
    }
  }

}

